<template>
  <div
    class="tw:bg-blue-200 tw:my-3 tw:py-4 tw:px-5 tw:rounded-xl tw:flex tw:md:flex-row tw:flex-col tw:justify-between tw:md:items-center"
  >
    <div class="tw:gap-x-[2px] tw:text-sm tw:text-blue-800">
      <p class="tw:font-bold">{{ $t('rc_overview_no_data_header') }}</p>
      <p>{{ $t('rc_overview_no_data_info') }}</p>
    </div>
    <div>
      <button
        class="tw:mt-4 tw:md:mt-0 tw:font-bold tw:text-sm tw:text-blue-800 tw:flex tw:items-center tw:hover:cursor-pointer tw:hover:underline"
        @click="redirectToRateConnect"
      >
        {{ $t('tbs_home_manage_campaign_cta') }}
        <ChevronRight class="tw:size-6" />
      </button>
    </div>
  </div>
</template>
<script setup>
import { useRouter } from 'vue-router'

import ChevronRight from '@/components/icons/ChevronRight.svg?component'

import appAnalytics from '@/utils/tracking'
import { selectedAccommodationId } from '@/layouts/queries'

const router = useRouter()
const redirectToRateConnect = () => {
  appAnalytics.track(appAnalytics.events.HOMEPAGE_RC_MANAGE_CAMPAIGN, {
    accommodationId: selectedAccommodationId.value,
  })
  router.push({ name: 'rate-connect-running-performance' })
}
</script>
